import { aiChatChartSeriesColors } from 'constants/colors';

/**
 * Lines a line chart holds, and slices a pie chart holds. One per series colour: a ninth series
 * would need a colour the palette does not have. Past the cap a line chart drops the rest and says
 * so; a pie chart folds the smallest slices into one.
 */
export const CHART_MAX_SERIES = aiChatChartSeriesColors.length;

/** Line width, in px. Thin, so eight lines still read apart. */
export const CHART_LINE_WIDTH = 2;

/** Marker radius, in px. Big enough to hover, small enough not to hide the line. */
export const CHART_POINT_RADIUS = 4;

/** Ring of surface colour between two slices, in px. */
export const CHART_SLICE_GAP = 2;

/** Height of the drawing, in px. The chat panel is narrow, so the chart is wider than tall. */
export const CHART_HEIGHT = 260;
